import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import '../../../css/support/support.scss';
import '../../../css/support/ageGate.scss';

// import main module definition.
import supportModule from './supportModule';

importFilesUnderPath(require.context('./constants/', true, /\.js$/));
importFilesUnderPath(require.context('./directives/', true, /\.js$/));
importFilesUnderPath(require.context('./controllers/', true, /\.js$/));
importFilesUnderPath(require.context('./services/', true, /\.js$/));

const templateContext = require.context('./', true, /\.html$/);

const templates = templateCacheGenerator(angular, 'supportHtmlTemplateApp', templateContext);

angular.element(() => {
    try {
        angular.bootstrap('#support:not([ng-modules])', [
            supportModule.name,
            templates.name
        ]);
    } catch (e) {
        console.warn('Angular has already been bootstrapped!');
    }
});

export default supportModule;
